import { nextTick } from 'vue'
import { translationService } from '../services/translation'

const waitForDOMUpdate = () => {
  return new Promise(resolve => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        resolve()
      })
    })
  })
}

export function useDataTranslation(componentRef, loadingRef, selector = '.min-h-screen.bg-white', setLoadingFn = null) {
  const translatePage = async () => {
    const currentLang = translationService.getLanguage()
    
    if (currentLang === 'en') {
      return
    }

    if (setLoadingFn) {
      setLoadingFn(true)
    }

    try {
      await nextTick()
      await waitForDOMUpdate()

      const element = componentRef.value || document.querySelector(selector)
      if (element) {
        const timeoutPromise = new Promise((_, reject) => {
          setTimeout(() => reject(new Error('Translation timeout')), 30000)
        })

        await Promise.race([
          translationService.translateElement(element),
          timeoutPromise
        ])

        await nextTick()
        await waitForDOMUpdate()
      }
    } catch (error) {
      console.error('Translation error in useDataTranslation:', error)
    } finally {
      if (setLoadingFn) {
        setLoadingFn(false)
      }
    }
  }

  const handleLanguageChange = async () => {
    if (loadingRef.value) {
      await new Promise((resolve) => {
        const checkLoading = setInterval(() => {
          if (!loadingRef.value) {
            clearInterval(checkLoading)
            resolve()
          }
        }, 100)

        setTimeout(() => {
          clearInterval(checkLoading)
          resolve()
        }, 10000)
      })
    }

    await translatePage()
  }

  const translateIfReady = async () => {
    if (!loadingRef.value && translationService.getLanguage() !== 'en') {
      await translatePage()
    }
  }

  return {
    translatePage,
    handleLanguageChange,
    translateIfReady
  }
}
